export const months = [
  { numero: '01', nome: 'Janeiro' },
  { numero: '02', nome: 'Fevereiro' },
  { numero: '03', nome: 'Março' },
  { numero: '04', nome: 'Abril' },
  { numero: '05', nome: 'Maio' },
  { numero: '06', nome: 'Junho' },
  { numero: '07', nome: 'Julho' },
  { numero: '08', nome: 'Agosto' },
  { numero: '09', nome: 'Setembro' },
  { numero: '10', nome: 'Outubro' },
  { numero: '11', nome: 'Novembro' },
  { numero: '12', nome: 'Dezembro' },
];
